export default __webpack_public_path__ + "static/media/PolygonxMooniverse.ba16dc18.png";